import createSliders from './create-slider.js';

function init() {
    const options = {
        slidesPerView: 1,
        watchOverflow: true,
        watchSlidesProgress: true,
        preloadImages: false,
        lazy: true,
    };

    createSliders('js_imageSlider', options);
}

$(document).ready(init);
